// extracted by mini-css-extract-plugin
export default {"nav":"appMenu_style_nav__DbC2j","nomeApp":"appMenu_style_nomeApp__OBM-1","nomeUsuario":"appMenu_style_nomeUsuario__F6ka+","sair":"appMenu_style_sair__+uT46"};